/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipologiaPratica } from './tipologia-pratica';


export interface PraticheCittadinoCountersFilter { 
    comune_slug?: string;
    tipo_pratica_id?: string;
    tipologia?: TipologiaPratica;
    data_da?: string;
    data_a?: string;
}



